import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";


export default function DeleteConfirmModal({onDelete, open, setOpen}){


    return (
        <Modal
            show={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Heading>Delete Confirm</Heading>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"success"}
                                onClick={onDelete}
                            >
                                Confirm
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                fullwidth
                                color={"info"}
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )

}